import { createFileRoute } from "@tanstack/react-router";
import { MeteoRiskLevelsPage } from "@/components/meteo-risk-levels-page";

export const Route = createFileRoute("/risk-levels")({
  head: () => ({
    meta: [
      { title: "Flood Risk Levels in Kenya | Meteo" },
      {
        name: "description",
        content:
          "Understand Meteo's four flood risk levels — Low, Watch, Warning, and Severe — and what action to take for each. Real-time flood alerts for all 47 Kenyan counties.",
      },
      { name: "robots", content: "index, follow" },
      {
        tagName: "link",
        rel: "canonical",
        href: "https://meteo.co.ke/risk-levels",
      },
      { property: "og:title", content: "Flood Risk Levels in Kenya | Meteo" },
      {
        property: "og:description",
        content:
          "Understand Meteo's four flood risk levels — Low, Watch, Warning, and Severe — and what action to take for each.",
      },
      { property: "og:url", content: "https://meteo.co.ke/risk-levels" },
      { property: "og:type", content: "website" },
    ],
  }),
  component: MeteoRiskLevelsPage,
});
